import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatButtonModule,
  MatCheckboxModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatToolbarModule,
  MatSidenavModule,
  MatProgressSpinnerModule } from '@angular/material';
import { TestRoutingModule } from './test-routing.module';

import { TestPageComponent } from './test-page/test-page.component';

@NgModule({
  imports: [
    CommonModule,
    TestRoutingModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatToolbarModule,
    MatSidenavModule,
    MatProgressSpinnerModule
  ],
  declarations: [TestPageComponent]
})
export class TestModule { }



// WEBPACK FOOTER //
// ./src/app/test/test.module.ts